/* eslint-disable no-param-reassign */
import { SystemFuncArgs } from '@brochington/ecstatic';
import CarnivoreDoc from 'editor/components/CarnivoreDoc';
import CarnivoreLib from 'editor/components/CarnivoreLib';
import CarnivoreSheet from 'editor/components/CarnivoreSheet';
import DOMOverlay from 'editor/components/DOMOverlay';
import EditorMode from 'editor/components/EditorMode';
import Tool, { EditorTools } from 'editor/components/Tool';
import { getScreenToSheetTransform } from 'editor/utils/transform';
import { Components } from '../../components';
import CarnivoreSheetEvents from '../../components/CarnivoreSheetEvents';
import MarkupKit from '../../components/MarkupKit';
import sheetEventsHandlers from './sheetEventHandlers';

export const addSheetEventsComponents = [
  CarnivoreDoc,
  CarnivoreLib,
  CarnivoreSheet,
  CarnivoreSheetEvents,
  DOMOverlay,
  EditorMode,
  MarkupKit,
  Tool,
];

export function addSheetEvents(args: SystemFuncArgs<Components>): void {
  const { components, world } = args;
  const carnDoc = components.get(CarnivoreDoc);
  const carnLib = components.get(CarnivoreLib);
  const sheetComp = components.get(CarnivoreSheet);
  const carnivoreSheetEvents = components.get(CarnivoreSheetEvents);
  const domOverlay = components.get(DOMOverlay);
  const { mode } = components.get(EditorMode);
  const markupKit = components.get(MarkupKit);
  const toolComp = components.get<Tool<EditorTools>>(Tool);

  const { sheet } = sheetComp;

  if (carnivoreSheetEvents.initialized) {
    return;
  }

  // @ts-ignore
  sheet.on(carnLib.SheetEvents.POINTER_DOWN, (evt, hit /* , transform */) => {
    const transform = getScreenToSheetTransform(world);
    hit = { x: hit.x * transform[0], y: hit.y * transform[3] };

    sheetEventsHandlers[toolComp.tool].mouseDown({
      world,
      evt,
      hit,
      carnDoc,
      sheetComp,
      domOverlay,
      markupKit,
      mode,
    });
  });

  // @ts-ignore
  sheet.on(carnLib.SheetEvents.POINTER_MOVE, (evt, hit /* transform */) => {
    const transform = getScreenToSheetTransform(world);
    hit = { x: hit.x * transform[0], y: hit.y * transform[3] };

    sheetEventsHandlers[toolComp.tool].mouseMove({
      world,
      evt,
      hit,
      carnDoc,
      sheetComp,
      domOverlay,
      markupKit,
      mode,
    });
  });

  // @ts-ignore
  sheet.on(carnLib.SheetEvents.POINTER_UP, (evt, hit /* , transform */) => {
    const transform = getScreenToSheetTransform(world);
    hit = { x: hit.x * transform[0], y: hit.y * transform[3] };

    sheetEventsHandlers[toolComp.tool].mouseUp({
      world,
      evt,
      hit,
      carnDoc,
      sheetComp,
      domOverlay,
      markupKit,
      mode,
    });
  });

  sheet.on(carnLib.SheetEvents.CLICK, (evt, hit /* , transform */) => {
    const transform = getScreenToSheetTransform(world);
    hit = { x: hit.x * transform[0], y: hit.y * transform[3] };

    sheetEventsHandlers[toolComp.tool].click({
      world,
      evt,
      hit,
      carnDoc,
      sheetComp,
      domOverlay,
      markupKit,
      mode,
    });
  });

  sheet.on(carnLib.SheetEvents.DBL_CLICK, (evt, hit /* , transform */) => {
    const transform = getScreenToSheetTransform(world);
    hit = { x: hit.x * transform[0], y: hit.y * transform[3] };

    sheetEventsHandlers[toolComp.tool].dblclick({
      world,
      evt,
      hit,
      carnDoc,
      sheetComp,
      domOverlay,
      markupKit,
      mode,
    });
  });

  // Initialize so the system doesn't run again.
  carnivoreSheetEvents.initialized = true;
}
